import React, { Component } from "react";
// import classes from './LegislationTable.module.css'
import AllStates from "../AllStates";
import ReactTable from "react-table";
import { withRouter } from "react-router-dom";

class AgencyTable extends Component {
  render() {
    let { agencyItems, mode } = this.props;
    let id = parseInt(localStorage.getItem("id"));
    let role = localStorage.getItem("project_role");
    mode = Number.parseInt(mode)
    switch (mode) {
      case 0:
        agencyItems = agencyItems.filter(
          a => a.data_status_id === 1 && a.created_by === id
        );
        break;
      case 1:
        agencyItems = agencyItems.filter(
          a => a.data_status_id === 1 && a.created_by === id
        );
        break;
      case 2:
        agencyItems = agencyItems.filter(
          a =>
            a.data_status_id === 2 &&
            (role.includes("USER") ? a.created_by === id : true)
        );
        break;
      case 3:
        agencyItems = agencyItems.filter(a => a.data_status_id === 3);
        break;
      default:
        break;
    }
    const columns = [
      {
        Header: "ID",
        accessor: "agency_id",
        id: "agency_id",
        show: false
      },
      {
        Header: "Agency Name",
        accessor: "agency_name",
        headerStyle: { fontWeight: "bold", textAlign: "left" },
        minWidth: 255
      },
      {
        Header: "Agency Short Name",
        accessor: "agency_short_name",
        id: "agency_short_name",
        maxWidth: 250,
        headerStyle: { fontWeight: "bold", textAlign: "left" }
      },
      {
        Header: "State",
        accessor: "state_id",
        id: "state_id",
        maxWidth: 250,
        Cell: props => AllStates[props.value - 1].state_name,
        headerStyle: { fontWeight: "bold", textAlign: "left" },
        filterMethod: (filter, row) => {
          return AllStates[row[filter.id] - 1].state_name
            .toLowerCase()
            .startsWith(filter.value.toLowerCase());
        }
      },
      {
        Header: "Budget Year",
        accessor: "budget_year",
        headerStyle: { fontWeight: "bold", textAlign: "left" },

        maxWidth: 200
      },
      {
        Header: "Project Budget ($Mil)",
        accessor: "capital_project_budget",
        id: "capital_project_budget",
        maxWidth: 250,
        headerStyle: { fontWeight: "bold", textAlign: "left" },
        Cell: props =>
          props.value ? props.value.toLocaleString() : props.value
      }
    ];
    let filterCaseInsensitive = (filter, row) => {
      const id = filter.pivotId || filter.id;
      return row[id]
        ? String(row[id])
            .toLowerCase()
            .startsWith(filter.value.toLowerCase())
        : false;
    };
    // console.log(agencyItems)
    return (
      <div className="my-auto">
        <ReactTable
          className="-highlight -striped my-auto"
          data={agencyItems}
          columns={columns}
          page={this.props.page}
          onPageChange={this.props.changePage}
          filterable
          defaultFilterMethod={filterCaseInsensitive}
          onFilteredChange={filters => {
            localStorage.setItem("agency_filters", JSON.stringify(filters))
          }}
          defaultFiltered={JSON.parse(localStorage.getItem("agency_filters"))||[]}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                if (rowInfo) this.props.clicked(rowInfo.row.agency_id);
                this.props.history.push("/agency/detail");
              }
            };
          }}
        />
      </div>
    );
  }
}

export default withRouter(AgencyTable);
